import Order from "./Order";
import { withNavigation } from "../../Common/withNavigation";
import { connect } from "react-redux";
import {
  getpendingorderRequest,
  getprocessingorderRequest,
  getshippedorderRequest,
  getdeliveredorderRequest,
  getallorderRequest,
  updateorderstatusRequest
} from "./Order-slice";

const mapStateToProps = (state) => {
  return {
    pendingorder: state.Order.getpendingorder?.count,
    processingorder: state.Order.getprocessingorder?.count,
    shippedorder: state.Order.getshippedorder?.count,
    deliveredorder: state.Order.getdeliveredorder?.count,
    allorderdata: state.Order.allorderdata?.data, 
    totalorder: state.Order.allorderdata?.total_orders, 
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getpendingorderRequest: () => dispatch(getpendingorderRequest()),
    getprocessingorderRequest: () => dispatch(getprocessingorderRequest()),
    getshippedorderRequest: () => dispatch(getshippedorderRequest()),
    getdeliveredorderRequest: () => dispatch(getdeliveredorderRequest()),
    getallorderRequest: () => dispatch(getallorderRequest()),
    updateorderstatusRequest: (data) => dispatch(updateorderstatusRequest(data)),
  };
};

export default withNavigation(
  connect(mapStateToProps, mapDispatchToProps)(Order)
);
